export const KILO_ATHLETE_APP_LINKS = {
  appStore: 'https://apps.apple.com/app/kilo-members/id6757883943',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.kiloAthletes.app',
} as const;

export function resolveOpenAppHref(userAgent: string = navigator.userAgent): string {
  return /android/i.test(userAgent) ? KILO_ATHLETE_APP_LINKS.googlePlay : KILO_ATHLETE_APP_LINKS.appStore;
}
